import styled from 'styled-components';

export const StyledPatientConfirmedUpdatePanel = styled.div`
   display: flex;
   flex-direction: column;
   gap: 16px;
   height: 100%;
`;

StyledPatientConfirmedUpdatePanel.displayName = 'StyledPatientConfirmedUpdatePanel';
